import { useState } from 'react';
import { Flex, IconButton, Input } from '@chakra-ui/react';
import { LuEye, LuEyeOff } from 'react-icons/lu';
import { useTranslation } from 'react-i18next';

function PasswordInput(props: React.ComponentProps<typeof Input>) {
  const { t } = useTranslation('common');
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Flex>
      <Input
        {...props}
        type={showPassword ? 'text' : 'password'}
        roundedEnd={0}
      />
      <IconButton
        aria-label={showPassword ? t('hidePassword') : t('showPassword')}
        variant="outline"
        onClick={() => setShowPassword(!showPassword)}
        roundedStart={0}
        borderLeftWidth={0}
      >
        {showPassword ? <LuEyeOff /> : <LuEye />}
      </IconButton>
    </Flex>
  );
}

export default PasswordInput;
